import React from 'react';

export function SkeletonVenueList() {
  return (
    <div data-testid="map-skeleton-list" style={{ display: 'grid', gap: 14, padding: '6px 16px 0' }}>
      {[0, 1, 2].map((i) => (
        <div key={i} className="premium-card" style={{ borderRadius: 26, overflow: 'hidden', background: 'var(--surface)', border: '1px solid rgba(112, 63, 246, 0.06)' }}>
          <div className="map-shimmer" style={{ width: '100%', aspectRatio: '16 / 9' }} />
          <div style={{ padding: '14px 16px 16px', display: 'grid', gap: 8 }}>
            <div className="map-shimmer" style={{ height: 18, width: '60%', borderRadius: 8 }} />
            <div className="map-shimmer" style={{ height: 12, width: '40%', borderRadius: 6 }} />
            <div className="map-shimmer" style={{ height: 10, width: '30%', borderRadius: 6, marginTop: 4 }} />
          </div>
        </div>
      ))}
    </div>
  );
}
